import { createFileRoute } from '@tanstack/react-router';

import { Appointments } from '../../features/personal/AppointmentsScreen';

/** `/personal/appointments` = المواعيد القادمة (خطة القسم الشخصي ش5). */
export const Route = createFileRoute('/personal/appointments')({ component: Appointments });
